(() => {
  const root = document.querySelector('[data-mega-menu]');
  if (!root) return;

  const nav = root.querySelector('[data-mm-nav]');
  const toggle = root.querySelector('[data-mm-toggle]');
  const backdrop = root.querySelector('[data-mm-backdrop]');
  const items = [...root.querySelectorAll('[data-mm-item]')];
  const desktopQuery = window.matchMedia('(min-width: 990px)');
  let closeTimer = null;

  const isDesktop = () => desktopQuery.matches;

  const setExpanded = (trigger, open) => {
    if (!trigger) return;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
  };

  const closeItem = (item) => {
    const trigger = item.querySelector('[data-mm-trigger]');
    const panel = item.querySelector('[data-mm-panel]');
    item.classList.remove('is-open');
    setExpanded(trigger, false);
    if (panel) panel.hidden = true;
  };

  const closeAll = () => {
    items.forEach(closeItem);
    if (backdrop) backdrop.hidden = true;
  };

  const openItem = (item) => {
    items.forEach((other) => {
      if (other !== item) closeItem(other);
    });
    const trigger = item.querySelector('[data-mm-trigger]');
    const panel = item.querySelector('[data-mm-panel]');
    item.classList.add('is-open');
    setExpanded(trigger, true);
    if (panel) panel.hidden = false;
    if (isDesktop() && backdrop) backdrop.hidden = false;
  };

  const setNavOpen = (open) => {
    root.classList.toggle('is-nav-open', open);
    if (toggle) setExpanded(toggle, open);
    if (!open) closeAll();
  };

  items.forEach((item) => {
    const trigger = item.querySelector('[data-mm-trigger]');
    const panel = item.querySelector('[data-mm-panel]');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const willOpen = !item.classList.contains('is-open');
      if (willOpen) openItem(item);
      else {
        closeItem(item);
        if (isDesktop() && backdrop) backdrop.hidden = true;
      }
    });

    item.addEventListener('mouseenter', () => {
      if (!isDesktop()) return;
      window.clearTimeout(closeTimer);
      openItem(item);
    });

    item.addEventListener('mouseleave', () => {
      if (!isDesktop()) return;
      closeTimer = window.setTimeout(() => {
        closeItem(item);
        if (!root.querySelector('.mm__item.is-open') && backdrop) {
          backdrop.hidden = true;
        }
      }, 140);
    });
  });

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      setNavOpen(!root.classList.contains('is-nav-open'));
    });
  }

  if (backdrop) {
    backdrop.addEventListener('click', () => closeAll());
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeAll();
      setNavOpen(false);
    }
  });

  desktopQuery.addEventListener('change', () => {
    closeAll();
    setNavOpen(false);
  });
})();
